export const validation = {
  blockTitleMaxChar: 10,
  blockParagraphMaxChar: 15,
  blocks: {
    min: 2,
    max: 12
  }
}
